import React from 'react';
import { ProductDto, StoreCategory } from 'types';
import { ProductListItem } from 'components/ProductList/ProductListItem';

const styles = { opacity: 0.5 };
export const DraggableProductListItemOverlay = (props: { product: ProductDto; storeCategory?: StoreCategory }) => {
    return (
        <div style={styles}>
            <ProductListItem
                product={props.product}
                storeCategory={props.storeCategory}
                draggableItem={true}
                onProductClick={null}
            />
        </div>
    );
};
